import styled from '@emotion/styled';

export const TableContainer = styled.div`
  .ui-table-row {
    cursor: pointer;
  }

  .ui-table-tbody .ui-table-cell:first-of-type {
    vertical-align: middle;
    text-align: center;
  }
`;

export const MissedFileIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.error};
`;

export const FileOkIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.success};
`;

export const AccountLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  max-width: min(360px, calc(100vw - 96px));

  > :not(:last-child) {
    flex-shrink: 0;
  }
`;

export const AccountName = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
